<div class="empty-state-container">
  <!-- Ícono -->
  <mat-icon class="empty-state-icon">{{ icon }}</mat-icon>

  <!-- Título -->
  <h2 class="empty-state-title">{{ title }}</h2>

  <!-- Descripción -->
  <p *ngIf="description" class="empty-state-description">
    {{ description }}
  </p>

  <!-- Contenido personalizado (slot adicional) -->
  <div class="empty-state-content">
    <ng-content></ng-content>
  </div>

  <!-- Acciones -->
  <div class="empty-state-actions" *ngIf="primaryButton || secondaryButton">
    <button 
      *ngIf="primaryButton" 
      mat-raised-button 
      color="primary"
      (click)="onPrimaryClick()"
      class="action-button">
      <mat-icon *ngIf="primaryButton.icon">{{ primaryButton.icon }}</mat-icon>
      {{ primaryButton.label }}
    </button>

    <button 
      *ngIf="secondaryButton" 
      mat-stroked-button
      (click)="onSecondaryClick()"
      class="action-button">
      <mat-icon *ngIf="secondaryButton.icon">{{ secondaryButton.icon }}</mat-icon>
      {{ secondaryButton.label }}
    </button>
  </div>
</div>
